import React, { useState } from 'react';
import './style.scss';
import { MarketNftStatuses } from '../Interfaces';
import TextField from '../../../controls/textField';
import Button from '../../../controls/button';
import useAlert from '../../../../contexts/alert';
import usePromo from './Context';
import clsx from 'clsx';

interface Props {
  status: MarketNftStatuses;
  className?: string;
}

const MarketPagePromoCode = ({ status, className }: Props) => {
  const alert = useAlert();
  const { apply } = usePromo();
  const [code, setCode] = useState('');
  const [valid, setValid] = useState(true);
  const [loading, setLoading] = useState(false);

  if (
    status !== MarketNftStatuses.AVAILABLE &&
    status !== MarketNftStatuses.FAILED
  ) {
    return null;
  }

  const handleCodeChange = (code: string) => {
    setValid(true);
    setCode(code);
  };

  const handleApply = () => {
    if (loading || code.length === 0) return;
    setLoading(true);
    apply(code, (result) => {
      if (result) {
        setCode('');
        alert.show('Code applied!');
      } else {
        alert.showError('Invalid code');
        setValid(false);
      }
      setLoading(false);
    });
  };

  return (
    <div className={clsx('market-page-promo-wrapper', className)}>
      <label className='market-page-promo-label' htmlFor='promo-code'>
        SECRET CODE:
      </label>
      <div className='market-page-promo'>
        <TextField
          id='promo-code'
          value={code}
          setValue={handleCodeChange}
          className='market-page-promo-field'
          align='left'
          disabled={loading}
          valid={valid}
          onEnterPress={handleApply}
        />
        <Button
          color='secondary'
          variant='contained'
          loading={loading}
          onClick={handleApply}
          className='market-page-promo-button'
          minified
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default MarketPagePromoCode;
